import { ArrowLeft } from 'lucide-react';
import { CustomerForm } from './CustomerForm';
import { useNavigate } from '../../hooks/useNavigate';

interface EditCustomerPageProps {
  customerId: string;
}

export function EditCustomerPage({ customerId }: EditCustomerPageProps) {
  const navigate = useNavigate();

  const handleSuccess = () => {
    navigate('customers');
  };

  const handleCancel = () => {
    navigate('customers');
  };

  return (
    <div className="min-h-screen bg-slate-100 p-6">
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <div className="mb-6">
          <button
            onClick={handleCancel}
            className="flex items-center gap-2 text-slate-600 hover:text-slate-900 transition-colors mb-4"
          >
            <ArrowLeft className="w-5 h-5" />
            Back to Customers
          </button>
          <h1 className="text-3xl font-bold text-slate-900">Edit Customer</h1>
          <p className="text-slate-600 mt-1">Update customer information</p>
        </div>

        {/* Form Card */}
        <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden">
          <CustomerForm
            customerId={customerId}
            onClose={handleCancel}
            onSuccess={handleSuccess}
            isModal={false}
          />
        </div>
      </div>
    </div>
  );
}
